import { routeConstants } from "src/utils/constants";
import goto from ".";
import { updateSessionState, getSessionState } from "../session";
import { getRouteId } from "src/utils/meristemContext";
import { getURLParams, updateForwardedParams } from "src/utils/urlParams";
import { disableGlobalExit } from "src/utils/globalExit";

declare module "src/pageDefinitions/session" {
  interface BrowserSessionState {
    freemiumOnboardingInitialRoute?: string;
    freemiumOnboardingSourceId?: string;
  }
}

export default {
  freemiumUpsellBranched() {
    // Store the current route ID and source info in session storage
    const currentRouteId = getRouteId();
    const urlParams = getURLParams();
    const currentRoute = urlParams.route || currentRouteId;

    updateSessionState("browser", {
      freemiumOnboardingInitialRoute: currentRoute,
      freemiumOnboardingSourceId: "app-free-onboarding",
    });

    goto.layer(
      "landing",
      "app-free-onboarding",
      false,
      routeConstants.freemiumBranched
    );
  },

  exitToFreemiumOnboarding(entryPoint = "freemiumOnboardingHealthGoals") {
    // Get the previous route from session storage
    const { freemiumOnboardingInitialRoute } = getSessionState("browser");
    updateForwardedParams({
      route: freemiumOnboardingInitialRoute,
    });

    // Clear the global exit flag from sessionStorage
    disableGlobalExit();

    // Navigate to main survey with the app-free-onboarding route and freemiumOnboardingHealthGoals entry point
    goto.mainSurvey(
      false,
      freemiumOnboardingInitialRoute || "app-free-onboarding",
      entryPoint
    );
  },

  exitFreemiumUpsell() {
    // Clear the global exit flag from sessionStorage
    disableGlobalExit();
    goto.exitBuyflow("USERPORTAL");
  },
};
